"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "enum": ["1", "2"],
  "enumNames": ["Innmeldt avvik", "FDV-runde"]
};
exports.default = _default;
module.exports = exports.default;